import { render } from "./Explanation.vue?vue&type=template&id=4d4cced3"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"
script.render = render

export default script